import React from "react";

import "./loader.styles.css";

export default function Loader({style}) {
  return <div className="loading" style={style}></div>;
}
